import React, { Component } from 'react'
import "../css/general-style.css"
import '../css/table-responsive.css'
import "../css/dashboard.css"
import { Menu } from "../components/Menu/Menu";
import LoadingWindow from '../components/LoadingWindow';
import { AiFillFileImage, AiOutlineCloudUpload, AiOutlineSave, AiOutlineDownload, AiOutlineWarning } from "react-icons/ai"
import { BsBoxSeam } from "react-icons/bs"
import { FiPlus } from "react-icons/fi"
import { pricesFormat } from '../functions/pricesFormat';
import Swal from "sweetalert2";
import { confirmCloseAlert } from '../functions/alerts'
import { getValueCookie } from '../services/cookieService';
import { getActualDateUTC, getDateFromReports } from '../functions/dateFormat';
import { create_Delete_Update_Information, getInformationWithDataV3, uploadFile } from '../services/CABE';
import ExcelDocument from '../components/ExcelDocument';
import { getDataSet } from '../functions/generateDataSetExcel';
import { PriceListModalV3 } from '../components/PriceList/PriceListModalV3';
import ProductBrowserV3 from '../components/ProductInformation/ProductBrowserV3';
import { resizeFile } from '../functions/reSizeImg';

const EMPTY_PRODUCT = {
    itemCode: "",
    abbreviatedDesc: "",
    completeDesc: "",
    ProductLine: "",
    ProductLineDesc: "",
    quantity: 0,
    ShipWeight: "",
    upc: '',
    upc2: '',
    caseupc: '',
    itemURLImage: '',
    LastDueDate: null,
    level1Price: null,
    level2Price: null,
    level3Price: null,
    cost: null,
    hasPricing: true,
}

const money = (v) => (v === null || v === undefined ? '—' : '$' + pricesFormat(v))

/**
 * PRODINFOV3-2026-10-18 — Products Information V3 (route /inventory/products-v3).
 *
 * Clone of pages/Inventory.js (left untouched at /inventory/products) whose prices come from Price
 * Management instead of Sage: the original read /Items/get (Sage IM_PriceCode for Mayaland, a cost+margin
 * formula for Altitude), which disagreed with Price Management (ticket 2026-10-16/18). Everything here is
 * RDS-only through /v3/inventory/products (backend: v3_controllers/productInformation.ts).
 *   - Mayaland shows Mayaland's prices, Altitude its own; levels 1, 2 and 3.
 *   - Products active in Sage but without a Price Management price are listed and flagged
 *     "No price in Price Management" (client's decision).
 *   - Cost: same rule as before (userType 1 sees it in the detail and the Excel; salesperson '0010' sees it
 *     in Browse Catalogue); the backend never sends it to anyone else.
 *   - "Download Inventory" is now available for both companies (the original was Mayaland-only).
 * Image upload and UPC editing keep using the same existing endpoints (/Items/updateImg, /Items/update).
 * One deliberate difference: the UPC inputs no longer fire a save on every keystroke — only the
 * "Save Changes" button saves (the original wired onKeyDown straight to the save routine).
 */
export default class InventoryV3 extends Component {

    constructor(props) {
        super(props)
        this.ModalLoading = React.createRef();
    }

    state = {
        Catalogue: [],
        Product: { ...EMPTY_PRODUCT },
        FileInfo: {
            Name: '',
            File: null
        },
    }

    selectInputFile() {
        var button = document.getElementById('formFileInventoryInformation')
        if (button) {
            button.click()
        }
    }

    // Called by ProductBrowserV3 when a card is picked.
    selectProduct = (row) => {
        this.setState({
            Product: { ...EMPTY_PRODUCT, ...row },
            FileInfo: { Name: '', File: null },
        })
    }

    onTarget = async (e) => {
        if (!e.target.files || e.target.files.length === 0) return

        // Max 3 MB image size validation
        const maxSizeInMB = 3;
        const maxSizeInBytes = maxSizeInMB * 1024 * 1024;

        if (e.target.files[0].size > maxSizeInBytes) {
            alert(`File too large. Maximum size is ${maxSizeInMB}MB`);
            return;
        }

        const pattern = /^image/
        if (pattern.test(e.target.files[0].type)) {
            const temporal = this.state.FileInfo
            temporal.Name = e.target.files[0].name
            temporal.File = await resizeFile(e.target.files[0], 375, 404, 0.5)
            this.setState({ FileInfo: temporal })
        } else {
            confirmCloseAlert('incorrect', 'The File is not a image please upload a correct File!')
            this.setState({
                FileInfo: {
                    Name: '',
                    File: null
                }
            })
        }
    }

    // Save Changes button (UPC / UPC 2 / Case UPC) — only enabled for the same user as the original page.
    onSaveUpc = async () => {
        const updatedProduct = this.state.Product;
        const data = {
            ItemCode: updatedProduct.itemCode,
            idCompany: Number(getValueCookie('CompanyId')),
            upc: updatedProduct.upc,
            upc2: updatedProduct.upc2,
            caseupc: updatedProduct.caseupc
        }
        const newUpc = document.getElementById('UPCInventoryInfo').value
        const newUpc2 = document.getElementById('UPC2InventoryInfo').value
        const newCaseupc = document.getElementById('CaseUPCInventoryInfo').value

        if (newUpc !== data.upc) {
            updatedProduct.upc = newUpc;
            data.upc = newUpc;
        }
        if (newUpc2 !== data.upc2) {
            updatedProduct.upc2 = newUpc2;
            data.upc2 = newUpc2;
        }
        if (newCaseupc !== data.caseupc) {
            updatedProduct.caseupc = newCaseupc;
            data.caseupc = newCaseupc;
        }

        const result = await create_Delete_Update_Information('/Items/update', data)
        if (result.status.code === 1) {
            this.setState({ Product: updatedProduct })
            confirmCloseAlert('correct', 'The identifiers were saved.')
        } else {
            confirmCloseAlert('incorrect', 'Whoops, something is wrong. Please try again! If the result is the same call System Support')
        }
    }

    async updateImage() {
        let imgPreview = ''
        if (this.state.FileInfo.File !== null) {
            imgPreview = URL.createObjectURL(this.state.FileInfo.File)
        }

        Swal.fire({
            title: 'Do you want to upload this image?',
            html:
                `<div class='ConfirmUpload'>
                <img src=${imgPreview !== '' ? imgPreview : '/assets/notavailable.png'} alt='Company' />
            </div>`,
            showCancelButton: true,
            confirmButtonText: 'Upload',
        }).then(async (result) => {

            if (result.isConfirmed) {
                this.ModalLoading.current.showState(true);
                const temporal = this.state.Product
                const data = {
                    ItemCode: temporal.itemCode,
                    idCompany: Number(getValueCookie('CompanyId')),
                    date: getActualDateUTC(),
                    createBy: getValueCookie('userName')
                }
                let formdata = new FormData()
                const blob = new Blob([JSON.stringify(data)], {
                    type: 'application/json'
                });
                await formdata.append('file', this.state.FileInfo.File, this.state.FileInfo.Name)
                await formdata.append("document", blob)

                const result2 = await uploadFile('/Items/updateImg', formdata, data)
                if (result2.status.code === 1) {
                    const bypassCache = new Date().getTime()
                    temporal.itemURLImage = `${result2.data[0].URL}?${bypassCache}`
                    await this.setState({
                        Product: temporal,
                        FileInfo: {
                            Name: '',
                            File: null
                        }
                    })

                    confirmCloseAlert('correct', 'The image for the Product: \n' + temporal.itemCode + '\nwas uploaded successfully')
                } else {
                    confirmCloseAlert('incorrect', 'Whoops, something is wrong. Please try again! If the result is the same call System Support')
                }

                this.ModalLoading.current.showState(false);
            }
        })
    }

    // "Download Inventory": loads the whole product universe once, then clicks the hidden Excel button
    // AFTER the state is committed (the data prop is built from state in render()).
    async downloadInventory() {
        this.ModalLoading.current.showState(true);
        let rows = []
        try {
            const response = await getInformationWithDataV3('/v3/inventory/products', {
                idCompany: Number(getValueCookie('CompanyId')),
                all: true,
            })
            if (response && response.status && response.status.code === 1 && Array.isArray(response.data)) {
                rows = response.data
            } else {
                confirmCloseAlert('incorrect', 'Whoops, the inventory could not be loaded. Please try again!')
            }
        } catch (error) {
            console.error('downloadInventory failed:', error)
            confirmCloseAlert('incorrect', 'Whoops, the inventory could not be loaded. Please try again!')
        }
        this.ModalLoading.current.showState(false);
        if (rows.length > 0) {
            this.setState({ Catalogue: rows }, () => {
                const button = document.getElementById('ExcelInventoryDataV3')
                if (button) button.click()
            })
        }
    }

    inventoryExcelData() {
        const isAdmin = getValueCookie('TypeUser') === '1'
        const rows = this.state.Catalogue.map((p) => ({
            itemCode: p.itemCode,
            ProductLineDesc: p.ProductLineDesc || '-',
            abbreviatedDesc: (p.completeDesc && p.completeDesc !== 'null') ? p.completeDesc : (p.abbreviatedDesc || '-'),
            quantity: p.quantity,
            cost: p.cost === null || p.cost === undefined ? '-' : p.cost,
            level1Price: p.hasPricing && p.level1Price !== null ? p.level1Price : '-',
            level2Price: p.hasPricing && p.level2Price !== null ? p.level2Price : '-',
            level3Price: p.hasPricing && p.level3Price !== null ? p.level3Price : '-',
            upc: p.upc || '-',
            upc2: p.upc2 || '-',
            caseupc: p.caseupc || '-',
            status: p.hasPricing ? 'OK' : 'No price in Price Management',
        }))
        if (isAdmin) {
            return getDataSet(rows,
                ['Item Code', 'Product Line', 'Description', 'On Hand', 'Cost', 'Level 1 Price', 'Level 2 Price', 'Level 3 Price', 'UPC', 'UPC 2', 'CASE UPC', 'Status'],
                ['itemCode', 'ProductLineDesc', 'abbreviatedDesc', 'quantity', 'cost', 'level1Price', 'level2Price', 'level3Price', 'upc', 'upc2', 'caseupc', 'status'])
        }
        return getDataSet(rows,
            ['Item Code', 'Product Line', 'Description', 'On Hand', 'Level 1 Price', 'Level 2 Price', 'Level 3 Price', 'UPC', 'UPC 2', 'CASE UPC', 'Status'],
            ['itemCode', 'ProductLineDesc', 'abbreviatedDesc', 'quantity', 'level1Price', 'level2Price', 'level3Price', 'upc', 'upc2', 'caseupc', 'status'])
    }

    render() {
        const product = this.state.Product
        const hasProduct = !!product.itemCode;
        const isSergio = getValueCookie('userName') === 'sergio.lopez';
        const isAdmin = getValueCookie('TypeUser') === '1';

        const tileStyle = { background: '#F8FAFC', border: '1px solid #E2E8F0', borderRadius: '10px', padding: '0.75rem 1.25rem' }
        const tileLabel = { fontSize: '0.7rem', fontWeight: 700, color: '#64748B', textTransform: 'uppercase', letterSpacing: '0.4px', margin: '0 0 2px' }

        // field helper
        const Field = ({ label, id, suffix, defaultValue, disabled = false, type = 'text' }) => (
            <div className="row mb-2">
                <label style={{ fontSize: '0.75rem', fontWeight: 700, color: '#64748B', textTransform: 'uppercase', letterSpacing: '0.3px', marginBottom: '4px' }}>
                    {label}
                </label>
                <div className="input-group" style={{ borderRadius: '8px', overflow: 'hidden', border: '1.5px solid #E2E8F0' }}>
                    <input
                        type={type}
                        id={id}
                        defaultValue={defaultValue}
                        disabled={disabled}
                        style={{ border: 'none', padding: '0.6rem 0.875rem', fontSize: '0.9375rem', flex: 1, outline: 'none' }}
                    />
                    {suffix && (
                        <span style={{ background: '#F8FAFC', border: 'none', borderLeft: '1.5px solid #E2E8F0', padding: '0 0.875rem', display: 'flex', alignItems: 'center', fontSize: '0.8125rem', color: '#64748B', fontWeight: 600 }}>
                            {suffix}
                        </span>
                    )}
                </div>
            </div>
        );

        return (
            <div className="dash-page container-fluid pb-5">
                <Menu Refresh={this.state.Refresh} Father={this} />
                <LoadingWindow ref={this.ModalLoading} />

                <div className="container-fluid" style={{ paddingTop: '1.5rem' }}>

                    {/* ── Hero ──────────────────────────────────────────── */}
                    <div style={{
                        background: 'linear-gradient(135deg, #0f172a 0%, #1e3a5f 60%, #2563EB 100%)',
                        borderRadius: '16px',
                        padding: '2rem 2.5rem',
                        marginBottom: '2rem',
                        marginTop: '2rem',
                        color: 'white',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        flexWrap: 'wrap',
                        gap: '1rem',
                    }}>
                        <div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '0.5rem' }}>
                                <BsBoxSeam style={{ fontSize: '1.75rem', opacity: 0.9 }} />
                                <h2 style={{ fontFamily: "'Archivo', sans-serif", fontWeight: 800, fontSize: '1.75rem', margin: 0 }}>
                                    Product Information
                                </h2>
                            </div>
                            <p style={{ margin: 0, opacity: 0.8, fontSize: '0.9375rem' }}>
                                {hasProduct
                                    ? `Viewing: ${product.itemCode} · ${product.abbreviatedDesc}`
                                    : 'Search, browse and manage your product catalogue · ' + getValueCookie('Company') + ' · Prices from Price Management'
                                }
                            </p>
                        </div>
                        <a
                            href="/inventory/new-item-wizard"
                            style={{
                                background: 'rgba(255,255,255,0.15)',
                                border: '1px solid rgba(255,255,255,0.3)',
                                borderRadius: '10px',
                                color: 'white',
                                textDecoration: 'none',
                                padding: '0.6rem 1.25rem',
                                fontSize: '0.875rem',
                                fontWeight: 600,
                                display: 'flex',
                                alignItems: 'center',
                                gap: '0.4rem',
                            }}
                        >
                            <FiPlus /> New Product
                        </a>
                    </div>

                    {/* ── Action bar ── */}
                    <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'stretch', marginBottom: '1.5rem', flexWrap: 'wrap', justifyContent: 'flex-end' }}>
                        <div style={{ display: 'flex', gap: '0.625rem', alignItems: 'stretch', flexShrink: 0, flexWrap: 'wrap' }}>

                            <PriceListModalV3
                                id={"PriceLevelListV3"}
                                title="Generate Price Level List (Price Management)"
                                hidden={false}
                                disabled={false}
                                titleButton='Print Price Levels'
                            />

                            <button
                                type="button"
                                onClick={() =>
                                    Swal.fire({
                                        title: 'Download Inventory?',
                                        text: 'This will export all product data to an Excel file.',
                                        icon: 'question',
                                        showCancelButton: true,
                                        confirmButtonColor: '#1e3a8a',
                                        cancelButtonColor: '#94A3B8',
                                        confirmButtonText: 'Yes, download',
                                        cancelButtonText: 'Cancel',
                                    }).then(result => { if (result.isConfirmed) this.downloadInventory(); })
                                }
                                style={{
                                    background: '#F1F5F9',
                                    border: '1.5px solid #E2E8F0',
                                    borderRadius: '10px',
                                    color: '#334155',
                                    padding: '0 1.25rem',
                                    fontWeight: 600,
                                    fontSize: '0.875rem',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '0.4rem',
                                    whiteSpace: 'nowrap',
                                }}
                            >
                                <AiOutlineDownload /> Inventory
                            </button>
                            <ExcelDocument
                                hidden={true}
                                id={"ExcelInventoryDataV3"}
                                data={this.inventoryExcelData()}
                                sheetname={"Inventory"}
                                archname={"INVENTORY COMPANY " + getValueCookie('Company') + " DATE " + getDateFromReports()}
                            />

                            <ProductBrowserV3
                                Padre={this}
                                titleButton='Browse Catalogue'
                            />
                        </div>
                    </div>

                    {/* ── Empty state ───────────────────────────────────── */}
                    {!hasProduct && (
                        <div style={{ textAlign: 'center', padding: '5rem 2rem', color: '#94A3B8' }}>
                            <BsBoxSeam style={{ fontSize: '3.5rem', marginBottom: '1rem', opacity: 0.3 }} />
                            <p style={{ margin: 0, fontSize: '1rem', color: '#64748B' }}>
                                <strong style={{ color: '#1e3a8a' }}>Browse the catalogue</strong> to get started.
                            </p>
                        </div>
                    )}

                    {/* ── Product detail ────────────────────────────────── */}
                    {hasProduct && (
                        // key forces remount when product changes → defaultValue inputs reset correctly
                        <div className="row g-4" key={product.itemCode}>

                            {/* ── LEFT: Image card ── */}
                            <div className="col-sm-12 col-lg-3">
                                <div className="card" style={{ borderRadius: '16px', border: '1px solid #E2E8F0', height: '100%' }}>
                                    <div className="card-body d-flex flex-column align-items-center justify-content-center" style={{ padding: '2rem 1.5rem' }}>
                                        <img
                                            key={product.itemURLImage}
                                            id='PrincipalImgInventory'
                                            src={product.itemURLImage || '/assets/notavailable.png'}
                                            alt={product.abbreviatedDesc}
                                            style={{ width: '100%', maxWidth: '220px', borderRadius: '12px', objectFit: 'contain', marginBottom: '1.5rem' }}
                                        />

                                        <button
                                            onClick={() => this.selectInputFile()}
                                            type="button"
                                            style={{
                                                background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)',
                                                border: 'none', borderRadius: '10px', color: 'white',
                                                padding: '0.625rem 1.25rem', fontWeight: 600, fontSize: '0.875rem',
                                                cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '0.4rem', width: '100%', justifyContent: 'center',
                                            }}
                                        >
                                            <AiFillFileImage /> Upload Image
                                        </button>
                                        <input accept="image/*" hidden type="file" id="formFileInventoryInformation" onChange={this.onTarget} />

                                        {this.state.FileInfo.Name !== '' && (
                                            <div style={{ marginTop: '1rem', textAlign: 'center', width: '100%' }}>
                                                <p style={{ fontSize: '0.78rem', color: '#64748B', marginBottom: '0.75rem' }}>
                                                    {this.state.FileInfo.Name}
                                                </p>
                                                <button
                                                    onClick={() => this.updateImage()}
                                                    type="button"
                                                    style={{
                                                        background: '#F0FDF4', border: '1.5px solid #86EFAC', borderRadius: '10px',
                                                        color: '#166534', padding: '0.6rem 1.25rem', fontWeight: 600, fontSize: '0.875rem',
                                                        cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '0.4rem', width: '100%', justifyContent: 'center',
                                                    }}
                                                >
                                                    <AiOutlineCloudUpload /> {product.itemURLImage ? 'Update' : 'Upload'}
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* ── RIGHT: Info card ── */}
                            <div className="col-sm-12 col-lg-9">
                                <div className="card" style={{ borderRadius: '16px', border: '1px solid #E2E8F0' }}>

                                    {/* ── Card header ── */}
                                    <div style={{
                                        background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)',
                                        borderRadius: '16px 16px 0 0',
                                        padding: '1.5rem 2rem',
                                        color: 'white',
                                    }}>
                                        {/* Badges row */}
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', flexWrap: 'wrap', marginBottom: '0.75rem' }}>
                                            <span style={{ background: 'rgba(255,255,255,0.2)', border: '1px solid rgba(255,255,255,0.25)', borderRadius: '8px', padding: '4px 12px', fontSize: '0.8rem', fontWeight: 700, letterSpacing: '0.5px' }}>
                                                {product.itemCode}
                                            </span>
                                            <span style={{ background: 'rgba(16,185,129,0.25)', border: '1px solid rgba(16,185,129,0.5)', borderRadius: '8px', padding: '4px 12px', fontSize: '0.8rem', fontWeight: 700 }}>
                                                On Hand: {product.quantity || 0}
                                            </span>
                                            {(product.ProductLine || product.ProductLineDesc) && (
                                                <span style={{ background: 'rgba(139,92,246,0.25)', border: '1px solid rgba(139,92,246,0.5)', borderRadius: '8px', padding: '4px 12px', fontSize: '0.8rem', fontWeight: 600 }}>
                                                    {product.ProductLineDesc || product.ProductLine}
                                                </span>
                                            )}
                                            {product.LastDueDate && (
                                                <span style={{ background: 'rgba(245,158,11,0.2)', border: '1px solid rgba(245,158,11,0.4)', borderRadius: '8px', padding: '4px 12px', fontSize: '0.8rem', fontWeight: 600 }}>
                                                    Last sale: {new Date(product.LastDueDate).toLocaleDateString()}
                                                </span>
                                            )}
                                        </div>

                                        {/* Product name */}
                                        <h3 style={{ fontFamily: "'Archivo', sans-serif", fontWeight: 700, fontSize: '1.25rem', margin: 0, lineHeight: 1.3 }}>
                                            {(product.completeDesc && product.completeDesc !== 'null')
                                                ? product.completeDesc
                                                : product.abbreviatedDesc}
                                        </h3>
                                    </div>

                                    <div className="card-body" style={{ padding: '1.75rem 2rem' }}>

                                        {/* ── Prices (Price Management) + cost + weight ── */}
                                        <div className="row g-3 mb-4">
                                            {isAdmin && product.cost > 0 && (
                                                <div className="col-auto">
                                                    <div style={tileStyle}>
                                                        <p style={tileLabel}>Unit Cost</p>
                                                        <p style={{ fontSize: '1.1rem', fontWeight: 700, color: '#0F172A', margin: 0 }}>{money(product.cost)}</p>
                                                    </div>
                                                </div>
                                            )}
                                            {product.hasPricing ? [1, 2, 3].map((level) => (
                                                <div className="col-auto" key={level}>
                                                    <div style={tileStyle}>
                                                        <p style={tileLabel}>Level {level} Price</p>
                                                        <p style={{ fontSize: '1.1rem', fontWeight: 700, color: '#2563EB', margin: 0 }}>{money(product['level' + level + 'Price'])}</p>
                                                    </div>
                                                </div>
                                            )) : (
                                                <div className="col-auto">
                                                    <div style={{ ...tileStyle, background: '#FFFBEB', border: '1px solid #FDE68A' }}>
                                                        <p style={{ ...tileLabel, color: '#92400E', display: 'flex', alignItems: 'center', gap: '4px' }}><AiOutlineWarning /> Price</p>
                                                        <p style={{ fontSize: '0.9rem', fontWeight: 700, color: '#92400E', margin: 0 }}>No price in Price Management</p>
                                                    </div>
                                                </div>
                                            )}
                                            {product.ShipWeight > 0 && (
                                                <div className="col-auto">
                                                    <div style={tileStyle}>
                                                        <p style={tileLabel}>Ship Weight</p>
                                                        <p style={{ fontSize: '1.1rem', fontWeight: 700, color: '#0F172A', margin: 0 }}>{product.ShipWeight} lbs</p>
                                                    </div>
                                                </div>
                                            )}
                                        </div>

                                        <div className="row g-4">

                                            {/* ── Identifiers section ── */}
                                            <div className="col-md-6">
                                                <p style={{ fontSize: '0.75rem', fontWeight: 700, color: '#64748B', textTransform: 'uppercase', letterSpacing: '0.6px', marginBottom: '1rem', borderBottom: '1px solid #E2E8F0', paddingBottom: '0.5rem' }}>
                                                    Identifiers
                                                </p>
                                                <Field label="UPC" id="UPCInventoryInfo" defaultValue={product.upc || ''} disabled={!isSergio} />
                                                <Field label="UPC 2" id="UPC2InventoryInfo" defaultValue={product.upc2 || ''} disabled={!isSergio} />
                                                <Field label="Case UPC" id="CaseUPCInventoryInfo" defaultValue={product.caseupc || ''} disabled={!isSergio} />
                                                <Field label="Unit of Measure" id="ItemUM" defaultValue="" />

                                                {isSergio && (
                                                    <button
                                                        type="button"
                                                        onClick={() => this.onSaveUpc()}
                                                        style={{
                                                            marginTop: '0.75rem', background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)',
                                                            border: 'none', borderRadius: '10px', color: 'white', padding: '0.75rem 1.5rem',
                                                            fontWeight: 600, fontSize: '0.9375rem', cursor: 'pointer',
                                                            display: 'flex', alignItems: 'center', gap: '0.5rem', width: '100%', justifyContent: 'center',
                                                        }}
                                                    >
                                                        <AiOutlineSave /> Save Changes
                                                    </button>
                                                )}
                                            </div>

                                            {/* ── Physical details section ── */}
                                            <div className="col-md-6">
                                                <p style={{ fontSize: '0.75rem', fontWeight: 700, color: '#64748B', textTransform: 'uppercase', letterSpacing: '0.6px', marginBottom: '1rem', borderBottom: '1px solid #E2E8F0', paddingBottom: '0.5rem' }}>
                                                    Physical Details
                                                </p>
                                                {/* Weight comes from ShipWeight — pre-filled */}
                                                <Field label="Weight" id="Itemweight" type="number" suffix="lbs" defaultValue={product.ShipWeight || ''} />
                                                <Field label="Length" id="ItemLength" type="number" suffix="in" defaultValue="" />
                                                <Field label="Height" id="ItemHeight" type="number" suffix="in" defaultValue="" />
                                                <Field label="Width" id="ItemWidth" type="number" suffix="in" defaultValue="" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    )}

                </div>
            </div>
        );
    }
}
